import Script from 'next/script';

export default function FacebookPixel() {
  return (
    <Script
      src="https://connect.facebook.net/en_US/fbevents.js"
      strategy="afterInteractive"
      id="facebook-pixel"
    />
  );
}
